import GameForm from '../index/components/GameForm.vue';
import PopupPicker from '../index/components/PopupPicker.vue';
import * as api from '../api/index';

export default {
    components: {
        GameForm,
        PopupPicker,
    },
    data() {
        return {
            pickerShow: false,
            pickerKey: '',
            pickerFormItem: {},
            gameForm: [],
            flatedGameForm: [],
            useDefault: false, // 是否使用选择项的第一个值作为默认值
        };
    },
    computed: {
        filteredFlattenGameForm() {
            return this.flatedGameForm.filter(formItem => !formItem.hidden);
        },
    },
    watch: {
        skuId(val) {
            if (!val || !this.pageInfo.product || this.pageInfo.product.category !== 'game') {
                // todo: 改为type
                return;
            }
            this.getSkuForm(val);
        },
    },
    methods: {
        handleClickFormItem(formItem) {
            this.pickerFormItem = formItem;
            this.pickerShow = true;
        },
        handlePick(value) {
            this.pickerFormItem.value = value;
            this.pickerShow = false;
            this.$nextTick(() => {
                this.resetFormSelect(value && value.form);
                this.flatedGameForm = this.flattenGameForm(this.gameForm);
            });
        },
        handleClosePicker() {
            this.pickerShow = false;
        },
        filterRealValues() {
            return;
        },
        formFormatter(formItemValue) {
            return formItemValue && formItemValue.value;
        },
        async formValidator(formItem) {
            return new Promise(resolve => {
                if (formItem.type == 'select' && formItem.options.length && !formItem.value) {
                    resolve('请选择' + formItem.label);
                } else if (formItem.type == 'input' && !formItem.value) {
                    resolve('请输入' + formItem.label);
                }
                resolve();
            });
        },
        flattenGameForm(treeData) {
            const vm = this;
            let targetPlaceholder = '';
            return treeData.reduce((arr, formItem) => {
                formItem.formatter = formItem.formatter || vm.formFormatter;
                formItem.validator = formItem.validator || vm.formValidator;

                if (formItem.type == 'input') {
                    targetPlaceholder = '请输入' + formItem.label;
                } else if (formItem.type == 'select') {
                    targetPlaceholder = '请选择' + formItem.label;
                }
                formItem.placeholder = formItem.placeholder || targetPlaceholder;
                formItem.value = formItem.value || null;
                formItem.hidden = false;
                if (formItem.options && formItem.options.length) {
                    arr = arr.concat(formItem);
                    if (!formItem.value) {
                        if (this.useDefault || (formItem.keyName === 'chargeGame' && formItem.options.length === 1)) {
                            formItem.value = formItem.options[0];
                        }
                    }
                    if (formItem.options.length === 1 && formItem.keyName === 'chargeGame') {
                        formItem.hidden = true;
                    }
                    const formItemValue = formItem.value;
                    if (formItemValue && formItemValue.form && formItemValue.form.length) {
                        arr = arr.concat(vm.flattenGameForm(formItem.value.form));
                    }
                } else if (formItem.type == 'input') {
                    arr = arr.concat(formItem);
                }
                return arr;
            }, []);
        },
        async getSkuForm(skuId) {
            const res = await api.getSkuForm({
                skuId,
            });
            if (res.code !== 0 || !res.data || !res.data.form) {
                throw new Error(res.msg || '网络开小差了,请稍后再试试吧~');
            }

            this.gameForm = res.data.form;
            this.flatedGameForm = this.flattenGameForm(res.data.form);

            // 游戏内编号 - 纯数字
            const gameNumber = this.flatedGameForm.find(i => i.keyName == 'contactQQ');
            gameNumber.validator = formItem => {
                return new Promise(resolve => {
                    if (!formItem.value) {
                        resolve('请输入游戏内编号');
                    }
                    if (!/^\d{1,}$/.test(formItem.value)) {
                        resolve('游戏编号均为数字，请正确填写');
                    }
                    resolve();
                });
            };
        },
        async validateForm() {
            return new Promise(resolve => {
                let p = [];
                this.flatedGameForm.forEach(formItem => {
                    if (formItem && formItem.validator) {
                        p.push(formItem.validator(formItem));
                    }
                });
                console.log(p);
                Promise.all(p).then(result => {
                    const err = result.find(err => err);
                    resolve(err);
                });
            });
        },
        resetFormSelect(formData) {
            if (!formData || !formData.length) {
                return;
            }
            formData.forEach(formItem => {
                if (formItem.value && formItem.value.form) {
                    this.resetFormSelect(formItem.value.form);
                    formItem.value = null;
                }
            });
        },
    },
};
